import { ReactComponent as Alert } from '../../../assets/icons/alert.svg';
import { ReactComponent as AlertLight } from '../../../assets/icons/alert-light.svg';
import { ReactComponent as AlertCircle } from '../../../assets/icons/alert-circle.svg';
import { ReactComponent as AlertCircleLight } from '../../../assets/icons/alert-circle-light.svg';
import { ReactComponent as ArrowDown } from '../../../assets/icons/arrow-down.svg';
import { ReactComponent as ArrowDownLight } from '../../../assets/icons/arrow-down-light.svg';
import { ReactComponent as ArrowRight } from '../../../assets/icons/arrow-right.svg';
import { ReactComponent as Bell } from '../../../assets/icons/bell.svg';
import { ReactComponent as Announcement } from '../../../assets/icons/announcement.svg';
import { ReactComponent as Bookmarks } from '../../../assets/icons/bookmarks.svg';
import { ReactComponent as Car } from '../../../assets/icons/car.svg';
import { ReactComponent as Date } from '../../../assets/icons/date.svg';
import { ReactComponent as Details } from '../../../assets/icons/details.svg';
import { ReactComponent as Extend } from '../../../assets/icons/extend-button.svg';
import { ReactComponent as ExtendLight } from '../../../assets/icons/extend-button-light.svg';
import { ReactComponent as Geofence } from '../../../assets/icons/geofence.svg';
import { ReactComponent as Home } from '../../../assets/icons/home.svg';
import { ReactComponent as Lightning } from '../../../assets/icons/lightning.svg';
import { ReactComponent as List } from '../../../assets/icons/list.svg';
import { ReactComponent as ListBox } from '../../../assets/icons/listbox.svg';
import { ReactComponent as Location } from '../../../assets/icons/location.svg';
import { ReactComponent as Logo } from '../../../assets/icons/logo.svg';
import { ReactComponent as LogoLight } from '../../../assets/icons/logo-light.svg';
import { ReactComponent as Notes } from '../../../assets/icons/notes.svg';
import { ReactComponent as Distance } from '../../../assets/icons/path-marker.svg';
import { ReactComponent as Photo } from '../../../assets/icons/photo.svg';
import { ReactComponent as Plus } from '../../../assets/icons/plus.svg';
import { ReactComponent as Pulse } from '../../../assets/icons/pulse.svg';
import { ReactComponent as Question } from '../../../assets/icons/question.svg';
import { ReactComponent as Roadwork } from '../../../assets/icons/roadwork.svg';
import { ReactComponent as RoundedArrowLeft } from '../../../assets/icons/rounded-arrow-left.svg';
import { ReactComponent as RoundedArrowRight } from '../../../assets/icons/rounded-arrow-right.svg';
import { ReactComponent as Search } from '../../../assets/icons/search.svg';
import { ReactComponent as SearchLight } from '../../../assets/icons/search-light.svg';
import { ReactComponent as SearchSmall } from '../../../assets/icons/search-small.svg';
import { ReactComponent as Settings } from '../../../assets/icons/settings.svg';
import { ReactComponent as SparkAlert } from '../../../assets/icons/spark-alert.svg';
import { ReactComponent as SparkAlertLight } from '../../../assets/icons/spark-alert-light.svg';
import { ReactComponent as Suitcase } from '../../../assets/icons/suitcase.svg';
import { ReactComponent as Time } from '../../../assets/icons/time.svg';
import { ReactComponent as Truck } from '../../../assets/icons/truck.svg';
import { ReactComponent as User } from '../../../assets/icons/user.svg';
import { ReactComponent as Users } from '../../../assets/icons/users.svg';
import { ReactComponent as UserManagement } from '../../../assets/icons/user-management.svg';
import { ReactComponent as Video } from '../../../assets/icons/video.svg';
import { ReactComponent as AddVideo } from '../../../assets/icons/add-video.svg';
import { ReactComponent as Weather } from '../../../assets/icons/weather.svg';
import { ReactComponent as CarOutlined } from '../../../assets/icons/car-outlined.svg';
import { ReactComponent as PhotoOutlined } from '../../../assets/icons/photo-outlined.svg';
import { ReactComponent as SparkOutlined } from '../../../assets/icons/spark-outlined.svg';
import { ReactComponent as Event } from '../../../assets/icons/event.svg';
import { ReactComponent as RiskLevel } from '../../../assets/icons/risk-level.svg';
import { ReactComponent as AssignedStatus } from '../../../assets/icons/assigned-status.svg';
import { ReactComponent as ChevronRight } from '../../../assets/icons/chevron-right.svg';
import { ReactComponent as ChevronRightLight } from '../../../assets/icons/chevron-right-light.svg';
import { ReactComponent as SettingsOutlined } from '../../../assets/icons/settings-outlined.svg';
import { ReactComponent as FlagOutlined } from '../../../assets/icons/flag-outlined.svg';
import { ReactComponent as MoonOutlined } from '../../../assets/icons/moon-outlined.svg';
import { ReactComponent as Clock } from '../../../assets/icons/clock.svg';
import { ReactComponent as ClockHistory } from '../../../assets/icons/clock-history.svg';
import { ReactComponent as LogOut } from '../../../assets/icons/log-out.svg';
import { ReactComponent as ViewAll } from '../../../assets/icons/view-all.svg';
import { ReactComponent as ViewAllLight } from '../../../assets/icons/view-all-light.svg';
import { ReactComponent as Move } from '../../../assets/icons/move.svg';
import { ReactComponent as CarHatchback } from '../../../assets/icons/car-hatchback.svg';
import { ReactComponent as ClipboardPlus } from '../../../assets/icons/clipboard-plus.svg';
import { ReactComponent as ArrowLeft } from '../../../assets/icons/arrow-left.svg';
import { ReactComponent as ArrowLeftLight } from '../../../assets/icons/arrow-left-light.svg';
import { ReactComponent as Close } from '../../../assets/icons/close.svg';
import { ReactComponent as CloseLight } from '../../../assets/icons/close-light.svg';
import { ReactComponent as EyeOff } from '../../../assets/icons/eye-off.svg';
import { ReactComponent as Trips } from '../../../assets/icons/trips.svg';
import { ReactComponent as Delete } from '../../../assets/icons/delete.svg';
import { ReactComponent as DeleteUserData } from '../../../assets/icons/delete-user-data.svg';
import { ReactComponent as URL } from '../../../assets/icons/link.svg';
import { ReactComponent as AddNote } from '../../../assets/icons/add-note.svg';
import { ReactComponent as EditNote } from '../../../assets/icons/edit-note.svg';
import { ReactComponent as Edit } from '../../../assets/icons/edit.svg';
import { ReactComponent as DocumentAward } from '../../../assets/icons/document-award.svg';
import { ReactComponent as Portrait } from '../../../assets/icons/portrait.svg';
import { ReactComponent as Summarize } from '../../../assets/icons/summarize.svg';
import { ReactComponent as Synced } from '../../../assets/icons/synced.svg';
import { ReactComponent as SyncPending } from '../../../assets/icons/sync-pending.svg';
import { ReactComponent as SyncFailed } from '../../../assets/icons/sync-failed.svg';
import { ReactComponent as SyncNotFound } from '../../../assets/icons/sync-not-found.svg';
import { ReactComponent as SyncGlobal } from '../../../assets/icons/synced-global.svg';
import { ReactComponent as SyncPendingGlobal } from '../../../assets/icons/sync-pending-global.svg';
import { ReactComponent as SyncGlobalLight } from '../../../assets/icons/synced-global-light.svg';
import { ReactComponent as SyncPendingGlobalLight } from '../../../assets/icons/sync-pending-global-light.svg';
import { ReactComponent as MergedTrip } from '../../../assets/icons/mergedTrip.svg';

import { IconKeys } from './IconKeys';
import S from './IconStyles';
import { useAppTheme } from '../../../theme/ThemeContext';

type IconType = {
  iconKey: IconKeys;
  className?: string;
};

function renderSwitch(key: IconKeys): JSX.Element | undefined {
  switch (key) {
    case IconKeys.LOGO:
      return <Logo />;
    case IconKeys.LOGO_LIGHT:
      return <LogoLight />;
    case IconKeys.ROUNDED_ARROW_RIGHT:
      return <RoundedArrowRight />;
    case IconKeys.ROUNDED_ARROW_LEFT:
      return <RoundedArrowLeft />;
    case IconKeys.CAR:
      return <Car />;
    case IconKeys.GEOFENCE:
      return <Geofence />;
    case IconKeys.HOME:
      return <Home />;
    case IconKeys.LIGHTNING:
      return <Lightning />;
    case IconKeys.LISTBOX:
      return <ListBox />;
    case IconKeys.PHOTO:
      return <Photo />;
    case IconKeys.PLUS:
      return <Plus />;
    case IconKeys.QUESTION:
      return <Question />;
    case IconKeys.SETTINGS:
      return <Settings />;
    case IconKeys.SUITCASE:
      return <Suitcase />;
    case IconKeys.USER:
      return <User />;
    case IconKeys.USERS:
      return <Users />;
    case IconKeys.USER_MANAGEMENT:
      return <UserManagement />;
    case IconKeys.VIDEO:
      return <Video />;
    case IconKeys.ADD_VIDEO:
      return <AddVideo />;
    case IconKeys.ARROW_RIGHT:
      return <ArrowRight />;
    case IconKeys.TIME:
      return <Time />;
    case IconKeys.DATE:
      return <Date />;
    case IconKeys.TRUCK:
      return <Truck />;
    case IconKeys.LOCATION:
      return <Location />;
    case IconKeys.DETAILS:
      return <Details />;
    case IconKeys.PULSE:
      return <Pulse />;
    case IconKeys.DISTANCE:
      return <Distance />;
    case IconKeys.ALERT:
      return <Alert />;
    case IconKeys.ALERT_LIGHT:
      return <AlertLight />;
    case IconKeys.ALERT_CIRCLE:
      return <AlertCircle />;
    case IconKeys.ALERT_CIRCLE_LIGHT:
      return <AlertCircleLight />;
    case IconKeys.ARROW_DOWN:
      return <ArrowDown />;
    case IconKeys.ARROW_DOWN_LIGHT:
      return <ArrowDownLight />;
    case IconKeys.SPARK_ALERT:
      return <SparkAlert />;
    case IconKeys.SPARK_ALERT_LIGHT:
      return <SparkAlertLight />;
    case IconKeys.ROADWORK:
      return <Roadwork />;
    case IconKeys.WEATHER:
      return <Weather />;
    case IconKeys.NOTES:
      return <Notes />;
    case IconKeys.BOOKMARKS:
      return <Bookmarks />;
    case IconKeys.BELL:
      return <Bell />;
    case IconKeys.ANNOUNCEMENT:
      return <Announcement />;
    case IconKeys.EXTEND:
      return <Extend />;
    case IconKeys.EXTEND_LIGHT:
      return <ExtendLight />;
    case IconKeys.SEARCH:
      return <Search />;
    case IconKeys.SEARCH_LIGHT:
      return <SearchLight />;
    case IconKeys.LIST:
      return <List />;
    case IconKeys.CAR_OUTLINED:
      return <CarOutlined />;
    case IconKeys.PHOTO_OUTLINED:
      return <PhotoOutlined />;
    case IconKeys.SPARK_OUTLINED:
      return <SparkOutlined />;
    case IconKeys.EVENT:
      return <Event />;
    case IconKeys.RISK_LEVEL:
      return <RiskLevel />;
    case IconKeys.ASSIGNED_STATUS:
      return <AssignedStatus />;
    case IconKeys.CHEVRON_RIGHT:
      return <ChevronRight />;
    case IconKeys.CHEVRON_RIGHT_LIGHT:
      return <ChevronRightLight />;
    case IconKeys.SETTINGS_OUTLINED:
      return <SettingsOutlined />;
    case IconKeys.FLAG_OUTLINED:
      return <FlagOutlined />;
    case IconKeys.MOON_OUTLINED:
      return <MoonOutlined />;
    case IconKeys.CLOCK:
      return <Clock />;
    case IconKeys.CLOCK_HISTORY:
      return <ClockHistory />;
    case IconKeys.LOG_OUT:
      return <LogOut />;
    case IconKeys.VIEW_ALL:
      return <ViewAll />;
    case IconKeys.VIEW_ALL_LIGHT:
      return <ViewAllLight />;
    case IconKeys.MOVE:
      return <Move />;
    case IconKeys.CAR_HATCHBACK:
      return <CarHatchback />;
    case IconKeys.CLIPBOARD_PLUS:
      return <ClipboardPlus />;
    case IconKeys.ARROW_LEFT:
      return <ArrowLeft />;
    case IconKeys.ARROW_LEFT_LIGHT:
      return <ArrowLeftLight />;
    case IconKeys.CLOSE:
      return <Close />;
    case IconKeys.CLOSE_LIGHT:
      return <CloseLight />;
    case IconKeys.EYE_OFF:
      return <EyeOff />;
    case IconKeys.SEARCH_SMALL:
      return <SearchSmall />;
    case IconKeys.TRIPS:
      return <Trips />;
    case IconKeys.DELETE:
      return <Delete />;
    case IconKeys.DELETE_USER_DATA:
      return <DeleteUserData />;
    case IconKeys.LINK:
      return <URL />;
    case IconKeys.ADD_NOTE:
      return <AddNote />;
    case IconKeys.EDIT_NOTE:
      return <EditNote />;
    case IconKeys.EDIT:
      return <Edit />;
    case IconKeys.DOCUMENT_AWARD:
      return <DocumentAward />;
    case IconKeys.PORTRAIT:
      return <Portrait />;
    case IconKeys.SUMMARIZE:
      return <Summarize />;
    case IconKeys.SYNCED:
      return <Synced />;
    case IconKeys.SYNC_PENDING:
      return <SyncPending />;
    case IconKeys.SYNC_FAILED:
      return <SyncFailed />;
    case IconKeys.SYNC_NOTFOUND:
      return <SyncNotFound />;
    case IconKeys.SYNCED_GLOBAL:
      return <SyncGlobal />;
    case IconKeys.SYNCED_GLOBAL_LIGHT:
      return <SyncGlobalLight />;
    case IconKeys.SYNC_PENDING_GLOBAL:
      return <SyncPendingGlobal />;
    case IconKeys.SYNC_PENDING_GLOBAL_LIGHT:
      return <SyncPendingGlobalLight />;
    case IconKeys.MERGED_TRIP:
      return <MergedTrip />;
    default:
      return undefined;
  }
}

function resolveThemeIconKey(iconKey: IconKeys, themeMode: 'dark' | 'light'): IconKeys {
  if (themeMode !== 'light') {
    return iconKey;
  }
  if (iconKey === IconKeys.EXTEND) {
    return IconKeys.EXTEND_LIGHT;
  }
  if (iconKey === IconKeys.SEARCH) {
    return IconKeys.SEARCH_LIGHT;
  }
  if (iconKey === IconKeys.VIEW_ALL) {
    return IconKeys.VIEW_ALL_LIGHT;
  }
  if (iconKey === IconKeys.CLOSE) {
    return IconKeys.CLOSE_LIGHT;
  }
  if (iconKey === IconKeys.SPARK_ALERT) {
    return IconKeys.SPARK_ALERT_LIGHT;
  }
  if (iconKey === IconKeys.ARROW_LEFT) {
    return IconKeys.ARROW_LEFT_LIGHT;
  }
  if (iconKey === IconKeys.CHEVRON_RIGHT) {
    return IconKeys.CHEVRON_RIGHT_LIGHT;
  }
  if (iconKey === IconKeys.ALERT) {
    return IconKeys.ALERT_LIGHT;
  }
  if (iconKey === IconKeys.ALERT_CIRCLE) {
    return IconKeys.ALERT_CIRCLE_LIGHT;
  }
  if (iconKey === IconKeys.ARROW_DOWN) {
    return IconKeys.ARROW_DOWN_LIGHT;
  }
  if (iconKey === IconKeys.SYNCED_GLOBAL) {
    return IconKeys.SYNCED_GLOBAL_LIGHT;
  }
  if (iconKey === IconKeys.SYNC_PENDING_GLOBAL) {
    return IconKeys.SYNC_PENDING_GLOBAL_LIGHT;
  }
  return iconKey;
}

function Icon({ iconKey, className = '' }: IconType): JSX.Element {
  const { themeMode } = useAppTheme();
  const resolvedIconKey = resolveThemeIconKey(iconKey, themeMode);

  return (
    <S.Wrapper className={`icon ai-center jc-center ${className}`}>
      {renderSwitch(resolvedIconKey)}
    </S.Wrapper>
  );
}

export default Icon;
